import i18n from 'i18next';
import bankConnectionService from '../../services/bankConnectionService';

const fetchLinkToken = async (orderId: string) => {
  const language = i18n.resolvedLanguage;
  const { data, errors } = await bankConnectionService.generateBankConnectorToken(orderId, language);
  if (errors) {
    throw errors;
  }
  return data?.generateBankConnectorToken;
};

export default fetchLinkToken;
